import { UploadedFile } from "@/types/file-upload";
import { BrNode, GroupNode, Result, SingleNode } from "@/types/result";

export function arrayToObj(array: string[]) {
  const obj = [];
  for (let i = 0; i < array.length; i++) {
    obj.push({ name: array[i], checked: true });
  }
  return obj;
}

type TreeNode = Result | GroupNode | BrNode | SingleNode;

export function countSingleLevels(node: TreeNode) {
  let count = 0;

  if (node.level === "single") {
    count += 1;
  }

  if ("children" in node && node.children && node.children.length > 0) {
    for (const child of node.children) {
      count += countSingleLevels(child);
    }
  }

  return count;
}

export function ceilToPlace(num: number, place: number) {
  const multiplier = Math.pow(10, place);
  return Math.ceil(num / multiplier) * multiplier;
}

export const findObject = (obj: { label: string }[], value: string) => {
  const returnData = obj.filter((val) =>
    val.label.toLowerCase().includes(value.toLowerCase())
  );
  return returnData;
};

export const setNum = (value: number) => {
  return String(value < 10 ? "0" + value : value);
};

export function calculateLog2(number: number) {
  if (number <= 0 || typeof number !== "number" || Number.isNaN(number)) {
    return 0;
  }

  return Math.log2(number);
}

export function log2ToDecimal(log2Value: number) {
  if (log2Value <= 0 || typeof log2Value !== "number") {
    return 0;
  }
  return Math.pow(2, log2Value);
}

export const setNumber = (value: number) => {
  return String(value).padStart(3, "0");
};

export function formatFileSize(bytes: number) {
  if (bytes === 0) return "0 Bytes";

  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));

  return Math.round(bytes / Math.pow(1024, i)) + " " + sizes[i];
}

export function getFileExtension(fileName: string | undefined): string {
  return fileName?.length
    ? fileName.substring(fileName.lastIndexOf(".") + 1, fileName.length)
    : "";
}

export function getLevel(fileName: string) {
  // 확장자를 제거하고 파일 이름만 추출
  const nameWithoutExtension = fileName?.replace(/\.[^/.]+$/, "");
  const parts = nameWithoutExtension?.split("_");

  return `${parts[parts.length - 3]}_${parts[parts.length - 2]}_${
    parts[parts.length - 1]
  }.mzML`;
}

export const isEqual = (obj1: unknown, obj2: unknown) => {
  return JSON.stringify(obj1) === JSON.stringify(obj2);
};

export const transformArray = (array: UploadedFile[]) => {
  const transformedArray = array?.map((item, index) => {
    // originalFileName을 "_"로 분리

    const name = item?.originalName ? item.originalName : item.name;

    const parts = name?.split("_");

    // 마지막 세 부분을 group, biologicalReplicate, replicate로 매핑
    const group = parseInt(parts[parts.length - 3], 10);
    const biologicalReplicate = parseInt(parts[parts.length - 2], 10);
    const replicate = parseInt(parts[parts.length - 1], 10);

    // 새로운 객체 생성
    return {
      orderNo: index + 1,
      fileName: `${item?.name}`,
      originalFileName: item?.originalName,
      group,
      biologicalReplicate,
      replicate,
      fileUploadId: item?.serverId,
      dataType: "DIA",
    };
  });

  return transformedArray;
};

export function convertToTitle(inputString: string) {
  return inputString
    .split("_") // 언더스코어를 기준으로 단어 분리
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // 각 단어의 첫 글자를 대문자로 변환
    .join(" "); // 공백으로 합치기
}

export function calculateCredits(totalSizeGB: number): number {
  if (totalSizeGB > 0 && totalSizeGB <= 1) {
    return 3;
  }

  return Math.round(totalSizeGB * 3);
}

export function bytesToGB(bytes: number, decimals = 2) {
  if (bytes === 0) return 0;

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;

  // 1 GB = 1024^3 bytes
  return parseFloat((bytes / Math.pow(k, 3)).toFixed(dm));
}
